module.exports = __webpack_public_path__ + "img/maze_star_g.a9997cd6.svg";